import { toast } from 'react-toastify';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as api from '../api/ratesApi';
import * as types from '../constants/ratesConstants';

export const getRatesActions = (search, unpaged) => async (dispatch) => {
  dispatch({ type: types.GET_RATES_REQUEST });
  try {
    const { error, data } = await api.getRates(search, unpaged);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: types.GET_RATES_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список оцінок вартості');
    dispatch({ type: types.GET_RATES_FAILURE });
  }
};

export const updateRateAction = (rate) => async () => {
  try {
    const { error } = await api.updateRate(rate);
    if (error) {
      throw new Error(error);
    }
    toast.success('Оцінка вартості була успішно змінена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити оцінку вартості');
  }
};

export const createRateAction = (rate) => async () => {
  try {
    const { error } = await api.createRate(rate);
    if (error) {
      throw new Error(error);
    }
    toast.success('Оцінка вартості була успішно додана');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати оцінку вартості');
  }
};

export const deleteRateAction = (rateId) => async () => {
  try {
    const { error } = await api.deleteRate(rateId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Оцінка вартості була успішно видалена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити оцінку вартості');
  }
};

export const clearRatesAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_RATES,
  });
};

export const setRatesPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({
    type: types.SET_RATES_PAGE_SIZE,
    payload: pageSize,
  });
};

export const setSelectedRateAction = (rate) => async (dispatch) => {
  dispatch({
    type: types.SELECT_RATE,
    payload: rate,
  });
};

export const clearSelectedRateAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_RATE,
  });
};

export const setRatesSearchAction = (search) => async (dispatch) => {
  dispatch({
    type: types.SET_RATES_SEARCH,
    payload: search,
  });
};

export const nextRatesPageAction = () => async (dispatch) => {
  dispatch({
    type: types.NEXT_RATES_PAGE,
  });
};

export const prevRatesPageAction = () => async (dispatch) => {
  dispatch({
    type: types.PREV_RATES_PAGE,
  });
};
